import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { Loyaltic } from './api-url.constants';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(
    private http: HttpClient
  ) { }

  sendMessage(
    name: string, 
    email: string, 
    //subject: string, 
    message: string
    ) {
        return this.http.post<any>(environment.baseUrl + Loyaltic.API.SendFeedback,
            {
              FeedbackName: name,
              FeedbackEmail: email,
              Subject: "NA",
              Message: message
            }).pipe(map(status => {

              return status;
            }));
      }
}
